import React from 'react';

import { ArtistFundraisingPickDelete } from '../ArtistFundraisingPickDelete';
import { EditButton } from '../ArtistFundraisingPickUpdate';
import type { Alertable, Editable } from '../types';

export function TitleActions(props: Alertable & Editable) {
  function stopEditing() {
    props.setIsEditing(false);
  }

  function startEditing() {
    props.setIsEditing(true);
  }

  if (props.isEditing) {
    return (
      <ArtistFundraisingPickDelete
        onConfirm={stopEditing}
        onCancel={() => {
          /*
           * User stays in edit mode if they cancel deletion. They then have the
           * option to exit edit mode via the cancel edit mode button.
           */
        }}
        onFailure={() => {
          props.setAlert({
            error: true,
            title: 'Something went wrong. Please try again.',
          });
        }}
        onSuccess={() => {
          props.setAlert({
            title:
              'We removed your fundraising link. It may take up to 24 hours to update on Spotify.',
          });
        }}
      />
    );
  }

  return <EditButton onClick={startEditing} />;
}
